import { useState, React } from 'react';
import _noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import DoubleArrowRight from 'sushiweb/Icons/all/DoubleArrowRight';
import Modal from 'sushiweb/Modal/Modal';
import Layout from 'sushiweb/Layout/Layout';
import Button from 'sushiweb/Button/Button';
import {
  ActionBottomButtonWrapper,
  ActionModalInputWrapper,
  ActionModalStyledInput,
  ActionModalWrapper,
} from '../../../../common/styles';

const RenameTeamModal = ({ teamData, isVisible, closeModal, heading }) => {
  const [newTeamName, setNewTeamName] = useState('');

  const handleAccept = () => {
    // handle when developing
    console.log('Accepted');
  };
  const updateTeamName = val => {
    if (val.length <= 50) {
      setNewTeamName(val);
    }
  };
  // handle when creating rename team flow
  console.log('Here', teamData);
  return (
    <>
      <Modal
        isCentered
        preventFocus
        visible={isVisible}
        onClose={closeModal}
        showCloseIcon
        title={heading}
        padding='2rem'
      >
        <ActionModalWrapper>
          <Layout>
            <Layout.Item colD={12} colT={12} colM={12}>
              <ActionModalInputWrapper>
                <ActionModalStyledInput
                  innerWidth='100%'
                  label='New team name'
                  value={newTeamName}
                  onChange={updateTeamName}
                  type='text'
                />
              </ActionModalInputWrapper>
            </Layout.Item>
          </Layout>
          <ActionBottomButtonWrapper>
            <Button
              onClick={handleAccept}
              // loading={creatingGroup}
              // disabled={!disabled}
              icon={<DoubleArrowRight />}
              // iconAlign='right'
            >
              Cancel
            </Button>
            <Button
              onClick={handleAccept}
              // loading={creatingGroup}
              // disabled={!disabled}
              icon={<DoubleArrowRight />}
              // iconAlign='right'
            >
              Rename
            </Button>
          </ActionBottomButtonWrapper>
        </ActionModalWrapper>
      </Modal>
    </>
  );
};

RenameTeamModal.propTypes = {
  teamData: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  heading: PropTypes.string,
};

RenameTeamModal.defaultProps = {
  teamData: {},
  isVisible: false,
  closeModal: _noop,
  heading: '',
};

export default RenameTeamModal;
